import { z } from 'zod'

// RFC 9457 problem+json, as produced by apps/api/src/lib/problemDetails.ts.
// `errors` is this API's extension, carrying per-field validation messages.
export const ProblemDetailsSchema = z.object({
  type: z.string(),
  title: z.string(),
  status: z.number(),
  detail: z.string(),
  instance: z.string().optional(),
  errors: z.record(z.string(), z.array(z.string())).optional(),
})
export type ProblemDetails = z.infer<typeof ProblemDetailsSchema>
